import { getModule, getSlug, getPathWithSlug } from '../config/routes/guards/slug';

export const getHospitalTokenKey = (slug = getSlug()) =>
  `token${slug ? `-${slug}` : ''}`;

export const getHospitalToken = () => localStorage.getItem(getHospitalTokenKey());

export const clearHospitalToken = (slug = getSlug()) => {
  localStorage.removeItem(getHospitalTokenKey(slug));
};

export const isHospitalLoginRoute = () => getModule() === 'login';

export const getHospitalLoginPath = () => getPathWithSlug('login');
